import minutesToHours from "./minutesToHours";

export default function to24HourFormat(minutes: number): string {
  if (minutes < 0 || minutes > 60 * 23 + 59) {
    return "Ogiltig tid";
  }
  const minutePart = minutes % 60;
  const hours = minutesToHours(minutes - minutePart);
  return `${hours.toString().padStart(2, "0")}:${minutePart
    .toString()
    .padStart(2, "0")}`;
}
